import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function SDM20LHT(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_SDM20LHTS':
            return core.setSDM20LHTs(state, action.SDM20LHTs);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM20LHTS':
            return core.updateSDM20LHTs(state, action.SDM20LHTs);
        case 'MYFHE__FHEPRODUCT_SET_SDM20LHT_DETAILS':
            return core.setSDM20LHTDetails(state, action.SDM20LHTId, action.SDM20LHTDetails);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM20LHT_STATUS':
            return core.updateSDM20LHTStatus(state, action.productIdentifier, action.status);
        case 'MYFHE__FHEPRODUCT_MASTER_SWITCH_SDM20LHT':
            return core.switchSDM20LHTMaster(state, action.productIdentifier, action.masterId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_SDM20LHT':
            return core.dissociateUserFromSDM20LHT(state, action.productIdentifier, action.userId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SDM20LHT':
            return core.dissociateUserFromSDM20LHTAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM20LHT/reducer.js